export const PLACEMENT_TYPES = [
  { id: '1', label: 'intern' },
  { id: '2', label: 'tutor' },
  { id: '3', label: 'rejected' },
];
